import React, {Component} from "react";
import {Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle} from 'react-accessible-accordion';
import AppointmentMinute from "./AppointmentMinute";

class AppointmentHour extends Component {
    constructor(props) {
        super(props);
        this.state = {
          hours:[]
        };
        this.getStatusText = this.getStatusText.bind(this);
    }

    componentDidMount () {
        let {appointmentHours}=this.props;
        let hours=[];
        for (let hour in appointmentHours) {
            hours.push(hour);
        }
        hours.sort((hour1, hour2) => hour1 - hour2);
        this.setState({hours});
    }

    getStatusText(minutes) {
        console.log("minutes",minutes);
        let flag=true;
        for (let minute in minutes) {
            let {count,targetCount} = minutes[minute];
            if(count<targetCount){
                flag=false;
                break;
            }
        }
        if(flag)
            return <label style={{color: '#E5310A'}}>Tümü Dolu</label>
        else
            return "";
    }

    render() {
        return (
            <Accordion>
                {this.state.hours.map((hour, index) =>
                    <AccordionItem key={"accordion-item-"+index}>
                        <AccordionItemTitle className="accordion__title">
                            <h6 className="u-position-relative" style={{margin:"0px",marginLeft:"10px", textTransform:"none"}}>
                                <div className='col-sm-6 row' style={{paddingLeft: '45px'}}>
                                    <p style={{display:'inline', margin:0,padding:0}}>{hour +":00"} - {this.getStatusText(this.props.appointmentHours[hour])}</p>
                                </div>
                                <div className="accordion__arrow" role="presentation" />
                            </h6>
                        </AccordionItemTitle>
                        <AccordionItemBody>
                            <AppointmentMinute
                                hour={hour}
                                date={this.props.date}
                                loading={this.props.loading}
                                handleMinute={(date,hour,minute)=>this.props.handleHour(date,hour,minute)}
                                appointmentMinutes={this.props.appointmentHours[hour]}
                            />
                        </AccordionItemBody>
                    </AccordionItem>)
                }
        </Accordion>)
    }
}

export default AppointmentHour;